import { render, staticRenderFns } from "./LazyImage.vue?vue&type=template&id=37123468&scoped=true&"
import script from "./LazyImage.vue?vue&type=script&lang=js&"
export * from "./LazyImage.vue?vue&type=script&lang=js&"
import style0 from "./LazyImage.vue?vue&type=style&index=0&id=37123468&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37123468",
  null
  
)

export default component.exports